export const SET_STATISTICS_GENERATOR = "@STATISTICS_GENERATOR/SET";
export const SET_STATISTICS_FIGURE = "@STATISTICS_GENERATOR/SET_FIGURE";
